export const ecosystemPartnersData = (
  [
    {
      id: "27",
      attributes: {
        name: "Dechat",
        description:
          "Chat, discover and transact assets seamlessly within all applications fully automated by Al.",
        url: "https://www.dechat.io",
        priority: null,
        ecosystem_partner_categories: {
          data: [
            {
              id: "4",
              attributes: { Name: "AI" },
            },
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "721",
              attributes: {
                url: "/partners/dechat.png",
                width: 617,
                height: 133,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "52",
      attributes: {
        name: "Lumia",
        description:
          "Lumia is the world’s first next-gen modular L2 designed to provide deep liquidity, unmatched capital efficiency, and essential infrastructure for the future Real-World Assets.",
        url: "https://lumia.org/",
        priority: null,
        ecosystem_partner_categories: {
          data: [
            {
              id: "3",
              attributes: { Name: "Blockchains" },
            },
            {
              id: "12",
              attributes: { Name: "RWA" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "729",
              attributes: {
                url: "/partners/lumia.png",
                width: 625,
                height: 167,
              },
            },
          ],
        },
        landing_logo: {
          data: [
            {
              id: "729",
              attributes: {
                url: "/partners/lumia.png",
                width: 625,
                height: 167,
              },
            },
          ],
        },
      },
    },
    {
      id: "12",
      attributes: {
        name: "Areon",
        description: "A cost-effective and stable Layer 1 network.",
        url: "https://areon.network/",
        priority: null,
        ecosystem_partner_categories: {
          data: [
            {
              id: "3",
              attributes: { Name: "Blockchains" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "715",
              attributes: {
                url: "/partners/areon.png",
                width: 713,
                height: 713,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "62",
      attributes: {
        name: "Guarda",
        description:
          "Guarda Wallet is a non-custodial, multi-currency wallet designed to securely store, manage, and exchange a wide range of digital assets.",
        url: "https://guarda.com/",
        priority: 100,
        ecosystem_partner_categories: {
          data: [
            {
              id: "2",
              attributes: { Name: "DeFi" },
            },
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "737",
              attributes: {
                url: "/partners/guarda.svg",
                width: 216,
                height: 278,
              },
            },
          ],
        },
        landing_logo: {
          data: [
            {
              id: "737",
              attributes: {
                url: "/partners/guarda.svg",
                width: 216,
                height: 278,
              },
            },
          ],
        },
      },
    },
    {
      id: "60",
      attributes: {
        name: "DWF Labs",
        description:
          "DWF Labs is the new generation Web3 investor and market maker, one of the world's largest high-frequency cryptocurrency trading entities.",
        url: "https://www.dwf-labs.com/",
        priority: 100,
        ecosystem_partner_categories: {
          data: [
            {
              id: "20",
              attributes: { Name: "Ventures" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "707",
              attributes: {
                url: "/partners/dwf-labs.png",
                width: 800,
                height: 800,
              },
            },
          ],
        },
        landing_logo: {
          data: [
            {
              id: "707",
              attributes: {
                url: "/partners/dwf-labs.png",
                width: 800,
                height: 800,
              },
            },
          ],
        },
      },
    },
    {
      id: "63",
      attributes: {
        name: "CoinRabbit",
        description:
          "CoinRabbit is an all-in-one crypto app where you can store, trade, grow and borrow against $PROM and 300+ assets with ease.",
        url: "https://coinrabbit.io/",
        priority: 100,
        ecosystem_partner_categories: {
          data: [
            {
              id: "2",
              attributes: { Name: "DeFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "738",
              attributes: {
                url: "/partners/coinrabbit.png",
                width: 808,
                height: 160,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "61",
      attributes: {
        name: "Marlin",
        description:
          "Marlin allows computations to be delegated to offchain microservices with proofs and attestations verified onchain.",
        url: "https://www.marlin.org/",
        priority: 98,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "708",
              attributes: {
                url: "/partners/marlin.png",
                width: 512,
                height: 512,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "51",
      attributes: {
        name: "DeXe DAO Studio",
        description:
          "Create and manage DAOs. Enhance governance and community interaction through one seamless interface.",
        url: "https://www.dexe.io/",
        priority: 97,
        ecosystem_partner_categories: {
          data: [
            {
              id: "6",
              attributes: { Name: "DAO" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "727",
              attributes: {
                url: "/partners/dexe-dao-studio.png",
                width: 309,
                height: 64,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "56",
      attributes: {
        name: "Subsquid",
        description:
          "SQD ingests and stores petabytes of raw blockchain data unlocking indexing and data access at a speed, scale, and price never before possible.",
        url: "https://www.sqd.dev/",
        priority: 97,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
            {
              id: "19",
              attributes: { Name: "Cloud Solutions" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "703",
              attributes: {
                url: "/partners/subsquid.png",
                width: 1400,
                height: 369,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "35",
      attributes: {
        name: "Zealy",
        description:
          "Zealy is the ultimate tool for growth hacking, offering limitless possibilities for communities to thrive and projects to build loyalty with their followers.",
        url: "https://zealy.io/",
        priority: 96,
        ecosystem_partner_categories: {
          data: [
            {
              id: "23",
              attributes: { Name: "QuestFi" },
            },
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "682",
              attributes: {
                url: "/partners/zealy.svg",
                width: 366,
                height: 134,
              },
            },
          ],
        },
        landing_logo: {
          data: [
            {
              id: "709",
              attributes: {
                url: "/partners/zealy-landing.png",
                width: 180,
                height: 180,
              },
            },
          ],
        },
      },
    },
    {
      id: "49",
      attributes: {
        name: "Bailsec",
        description:
          "Bail Security provides Smart Contract Audits conducted by experienced senior auditors emphasis on launching safely.",
        url: "https://bailsec.io",
        priority: 95,
        ecosystem_partner_categories: {
          data: [
            {
              id: "8",
              attributes: { Name: "Auditors & Security" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "696",
              attributes: {
                url: "/partners/bailsec.webp",
                width: 280,
                height: 121,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "64",
      attributes: {
        name: "ChangeNow",
        description:
          "ChangeNOW is a personal secure crypto management platform that secures a fast route to access Web3 finance via a time-tested simple interface.",
        url: "https://changenow.io/",
        priority: 94,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "740",
              attributes: {
                url: "/partners/changenow.svg",
                width: 173,
                height: 99,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "48",
      attributes: {
        name: "Automata Network",
        description:
          "A modular attestation layer extending machine-level trust to Ethereum.",
        url: "https://www.ata.network",
        priority: 94,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "730",
              attributes: {
                url: "/partners/automata-network.svg",
                width: 1230,
                height: 400,
              },
            },
          ],
        },
        landing_logo: {
          data: [
            {
              id: "730",
              attributes: {
                url: "/partners/automata-network.svg",
                width: 1230,
                height: 400,
              },
            },
          ],
        },
      },
    },
    {
      id: "50",
      attributes: {
        name: "Blockscout",
        description:
          "Open-source, universally accessible, and fully customizable Explorer Portal.",
        url: "https://www.blockscout.com/",
        priority: 93,
        ecosystem_partner_categories: {
          data: [
            {
              id: "17",
              attributes: { Name: "Explorers" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "697",
              attributes: {
                url: "/partners/blockscout.svg",
                width: 160,
                height: 30,
              },
            },
          ],
        },
        landing_logo: {
          data: [
            {
              id: "697",
              attributes: {
                url: "/partners/blockscout.svg",
                width: 160,
                height: 30,
              },
            },
          ],
        },
      },
    },
    {
      id: "16",
      attributes: {
        name: "Linear Finance",
        description:
          "Linear provides seamless access to a diverse range of synthetic assets and decentralized financial services.",
        url: "https://linear.finance/",
        priority: 92,
        ecosystem_partner_categories: {
          data: [
            {
              id: "2",
              attributes: { Name: "DeFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "722",
              attributes: {
                url: "/partners/linear-finance.png",
                width: 2500,
                height: 695,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "43",
      attributes: {
        name: "NEAR",
        description:
          "NEAR’s Data Availability solution offers low costs, a reliable underlying structure, allowing developers to make the most of the NEAR out-of-the-box tools for building.",
        url: "https://near.org/",
        priority: 91,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "690",
              attributes: { url: "/partners/near.svg", width: 110, height: 28 },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "14",
      attributes: {
        name: "Avail",
        description:
          "A Web3 infrastructure layer that allows modular execution layers to scale and interoperate in a trust minimized way.",
        url: "https://www.availproject.org/",
        priority: 91,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "660",
              attributes: {
                url: "/partners/avail.png",
                width: 447,
                height: 130,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "53",
      attributes: {
        name: "RWA",
        description:
          "The tokenization of real-world assets is a major milestone for bringing mass adoption closer and a unique way to bridge Web3 with the physical world.",
        url: "https://www.rwa.inc/",
        priority: 90,
        ecosystem_partner_categories: {
          data: [
            {
              id: "12",
              attributes: { Name: "RWA" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "700",
              attributes: {
                url: "/partners/rwa.svg",
                width: 1273,
                height: 533,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "13",
      attributes: {
        name: "SoonVerse",
        description:
          "An AIGG platform where AI powers every stage of gaming development, streamlining processes and enhancing creativity to deliver unparalleled gaming experiences.",
        url: "https://www.soonverse.xyz/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "4",
              attributes: { Name: "AI" },
            },
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "659",
              attributes: {
                url: "/partners/soonverse.png",
                width: 84,
                height: 84,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "19",
      attributes: {
        name: "XRADERS",
        description:
          "XRADERS delivers real-time market info through a community-driven approach that boosts valuable expert opinions through a Guess2Earn model.",
        url: "https://xraders.xyz/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "15",
              attributes: { Name: "EdFi" },
            },
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "714",
              attributes: {
                url: "/partners/xraders.png",
                width: 1000,
                height: 1000,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "20",
      attributes: {
        name: "LILLIUS",
        description:
          "LILLIUS innovates the world of fitness and sports with blockchain and AI, powering your fitness journey with a reward system and precise motion recognition technology.",
        url: "https://www.lillius.net/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "4",
              attributes: { Name: "AI" },
            },
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "735",
              attributes: {
                url: "/partners/lillius.png",
                width: 855,
                height: 612,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "11",
      attributes: {
        name: "Klink Finance",
        description:
          "Klink is a leading crypto platform offering a unique blend of quest-based task rewards and high-growth investment opportunities.",
        url: "https://www.klinkfinance.com/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "23",
              attributes: { Name: "QuestFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "713",
              attributes: {
                url: "/partners/klink-finance.png",
                width: 508,
                height: 133,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "33",
      attributes: {
        name: "Galaxis",
        description:
          "Galaxis offers a clean-cut infrastructure for creators to monetize creativity and connect seamlessly with their followers.",
        url: "https://galaxis.xyz/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "717",
              attributes: {
                url: "/partners/galaxis.png",
                width: 2644,
                height: 1387,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "31",
      attributes: {
        name: "MVL",
        description:
          "MVL is revolutionizing the mobility industry by utilizing blockchain technology to integrate mobility services, including TADA and ONiON Mobility, with Web3. ",
        url: "https://mvlchain.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
            {
              id: "12",
              attributes: { Name: "RWA" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "678",
              attributes: { url: "/partners/mvl.png", width: 53, height: 41 },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "41",
      attributes: {
        name: "Hippocrat",
        description:
          "Hippocrat aims to bring an open, collaborative workflow to the healthcare industry that is traditionally tied to centralized entities and lacks control over personal information.",
        url: "https://hippocrat.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "16",
              attributes: { Name: "DeSci" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "688",
              attributes: {
                url: "/partners/hippocrat.png",
                width: 384,
                height: 108,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "46",
      attributes: {
        name: "IQ.wiki",
        description:
          "IQ.wiki powers the crypto space by providing access to a knowledge base on everything related to key industry players and personalities, all stored on the blockchain.",
        url: "https://iq.wiki/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "15",
              attributes: { Name: "EdFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "693",
              attributes: {
                url: "/partners/iq-wiki.svg",
                width: 186,
                height: 58,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "39",
      attributes: {
        name: "Chainspot",
        description:
          "Chainspot brings seamless DeFi interactions to the table through cross-chain liquidity aggregation and a smart routing engine. ",
        url: "https://chainspot.io/portal",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "18",
              attributes: { Name: "Bridges" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "686",
              attributes: {
                url: "/partners/chainspot.webp",
                width: 256,
                height: 51,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "37",
      attributes: {
        name: "Koi",
        description:
          "Koi is an ever-expanding platform, already offering to maximize your potential through BRC trading, BTC restaking, and BRC 404 swapping.",
        url: "https://koitrading.io",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "9",
              attributes: { Name: "BTCFI" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "684",
              attributes: { url: "/partners/koi.png", width: 350, height: 350 },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "45",
      attributes: {
        name: "Nexis Network",
        description:
          "Nexis Network is a Web3 infrastructure protocol offering building, scaling, and growth solutions.",
        url: "https://nexis.network/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "692",
              attributes: {
                url: "/partners/nexis-network.avif",
                width: 0,
                height: 0,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "55",
      attributes: {
        name: "Superboard",
        description:
          "Superboard, an omnichain discovery platform, stands at the forefront of user onboarding, providing an innovative pathway for learning and engagement in the Web3 space.",
        url: "https://superboard.xyz",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "23",
              attributes: { Name: "QuestFi" },
            },
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "702",
              attributes: {
                url: "/partners/superboard.svg",
                width: 58,
                height: 41,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "54",
      attributes: {
        name: "Midle",
        description:
          "Midle offers a straightforward approach for users to engage in tasks and get rewarded, while providing projects a new avenue for user acquisition, engagement, and retention.",
        url: "https://midle.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "23",
              attributes: { Name: "QuestFi" },
            },
            {
              id: "22",
              attributes: { Name: "Entertainment" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "701",
              attributes: {
                url: "/partners/midle.png",
                width: 600,
                height: 206,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "47",
      attributes: {
        name: "ColdStack",
        description:
          "A decentralized storage aggregator. The fastest way to store all your data in the cloud.",
        url: " https://coldstack.io",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
            {
              id: "19",
              attributes: { Name: "Cloud Solutions" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "694",
              attributes: {
                url: "/partners/coldstack.png",
                width: 200,
                height: 200,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "44",
      attributes: {
        name: "Dyor Exchange",
        description:
          "Dyor is a handbook for every Web3 enthusiast, providing discovery and portfolio management tools.",
        url: "https://dyor.exchange/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "2",
              attributes: { Name: "DeFi" },
            },
            {
              id: "21",
              attributes: { Name: " Decentralized Applications" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "691",
              attributes: {
                url: "/partners/dyor-exchange.svg",
                width: 1000,
                height: 1000,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "36",
      attributes: {
        name: "Spintop",
        description:
          "Spintop is a social platform that connects Web3 games and gamers with its tools and solutions.",
        url: "https://spintop.network/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "725",
              attributes: {
                url: "/partners/spintop.png",
                width: 1368,
                height: 1368,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "38",
      attributes: {
        name: "Udao",
        description:
          "Udao is a hub for all aspiring specialists seeking to fast-track their career paths in our era's rapidly changing work environment.",
        url: "https://udao.org",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "15",
              attributes: { Name: "EdFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "724",
              attributes: {
                url: "/partners/udao.png",
                width: 520,
                height: 281,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "34",
      attributes: {
        name: "Carrieverse",
        description:
          "Carrieverse is a virtual reality world that allows users to connect through social activities and gaming elements.",
        url: "https://www.carrieverse.com/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "736",
              attributes: {
                url: "/partners/carrieverse.png",
                width: 662,
                height: 338,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "22",
      attributes: {
        name: "Abelian",
        description: "A quantum-resistant blockchain infrastructure.",
        url: "https://pqabelian.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "669",
              attributes: {
                url: "/partners/abelian.svg",
                width: 760,
                height: 142,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "42",
      attributes: {
        name: "AirDAO",
        description:
          "AirDAO is an ecosystem of Web3 projects shaped by collective wisdom via DAO governance.",
        url: "https://airdao.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "6",
              attributes: { Name: "DAO" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "689",
              attributes: {
                url: "/partners/airdao.svg",
                width: 255,
                height: 56,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "9",
      attributes: {
        name: "Arena Games",
        description:
          "A multichain gaming ecosystem bridging Web2 and Web3 gaming. ",
        url: "https://arenavs.com/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "712",
              attributes: {
                url: "/partners/arena-games.png",
                width: 2340,
                height: 1349,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "5",
      attributes: {
        name: "Ackee",
        description: "An industry-leading cybersecurity auditor.",
        url: "https://ackee.xyz/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "8",
              attributes: { Name: "Auditors & Security" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "726",
              attributes: {
                url: "/partners/ackee.png",
                width: 625,
                height: 258,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "40",
      attributes: {
        name: "L2Faucet",
        description:
          "L2Faucet solution brings unparalleled sybil-resistance and privacy protection for both testnet users and products seeking to run a faucet.",
        url: "https://www.l2faucet.com",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "687",
              attributes: {
                url: "/partners/l2faucet.jpg",
                width: 400,
                height: 400,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "59",
      attributes: {
        name: "Mar3",
        description:
          "Mar3 stands out as a leading AI-powered SocialFi dApp, offering a unique platform for individuals to connect with others and earn rewards within the Web3 ecosystem.",
        url: "https://mar3.ai/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "4",
              attributes: { Name: "AI" },
            },
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
            {
              id: "21",
              attributes: { Name: " Decentralized Applications" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "706",
              attributes: { url: "/partners/mar3.png", width: 233, height: 56 },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "58",
      attributes: {
        name: "Port3",
        description:
          "Port3 Network is designed to simplify and consolidate all of the necessary infrastructure components to seamlessly facilitate the launch of any new AI-enabled application all while maintaining decentralization.",
        url: "https://port3.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
            {
              id: "21",
              attributes: { Name: " Decentralized Applications" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "705",
              attributes: {
                url: "/partners/port3.svg",
                width: 143,
                height: 35,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "30",
      attributes: {
        name: "Art de Finance",
        description:
          "Art de Finance unites artists, galleries, and art consumers, making art accessible, community-driven, and transparent.",
        url: "https://www.artdefinance.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "10",
              attributes: { Name: "NFT" },
            },
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "734",
              attributes: {
                url: "/partners/art-de-finance.png",
                width: 1001,
                height: 1000,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "57",
      attributes: {
        name: "Forward Protocol",
        description:
          "A WordPress-like model environment that alows users to develop and deploy blockchain applications without any code or technical knowledge.",
        url: "https://forwardprotocol.io",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "21",
              attributes: { Name: " Decentralized Applications" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "710",
              attributes: {
                url: "/partners/forward-protocol.png",
                width: 1200,
                height: 1200,
              },
            },
          ],
        },
        landing_logo: {
          data: [
            {
              id: "710",
              attributes: {
                url: "/partners/forward-protocol.png",
                width: 1200,
                height: 1200,
              },
            },
          ],
        },
      },
    },
    {
      id: "29",
      attributes: {
        name: "ARPA",
        description:
          "Verifiable on-chain randomness oracle, Randcast, which is now live on Ethereum, Optimism, Base, Redstone.",
        url: "https://www.arpanetwork.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "11",
              attributes: { Name: "Oracles" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "719",
              attributes: { url: "/partners/arpa.png", width: 220, height: 48 },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "3",
      attributes: {
        name: "Cyberscope",
        description:
          "Smart contract auditor and consultancy for blockchain space.",
        url: "https://www.cyberscope.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "8",
              attributes: { Name: "Auditors & Security" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "649",
              attributes: {
                url: "/partners/cyberscope.avif",
                width: 0,
                height: 0,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "26",
      attributes: {
        name: "BITLiquidity",
        description: "The first L1 + L2 Liquidity aggregator on Bitcoin.",
        url: "https://bitliquidity.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "9",
              attributes: { Name: "BTCFI" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "673",
              attributes: {
                url: "/partners/bitliquidity.svg",
                width: 983,
                height: 208,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "21",
      attributes: {
        name: "NADA Protocol",
        description:
          "NADA Protocol offers charming gameplay powered by P2E and diverse mechanics suitable for casual game fans and seasoned Web3 players.",
        url: "https://www.slimeworldnft.com/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
            {
              id: "10",
              attributes: { Name: "NFT" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "668",
              attributes: {
                url: "/partners/nada-protocol.png",
                width: 250,
                height: 250,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "4",
      attributes: {
        name: "H3 Entertainment",
        description:
          "An entertainment ecosystem combining Web3 with the movie making production process. Bridging the gap between studios, fans, investors, and creative talent.",
        url: "https://h3entertainment.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "22",
              attributes: { Name: "Entertainment" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "650",
              attributes: {
                url: "/partners/h3-entertainment.svg",
                width: 86,
                height: 30,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "24",
      attributes: {
        name: "BubbleFong Friends",
        description:
          "BubbleFong Friends offers fun gameplay suitable for gamers of every experience level and a sustainable P2E mechanism.",
        url: "https://bubblefong.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "671",
              attributes: {
                url: "/partners/bubblefong-friends.png",
                width: 117,
                height: 74,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "6",
      attributes: {
        name: "CeluvPlay",
        description: "An AI-based Web3 Entertainment Ecosystem.",
        url: "https://www.celuvplay.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "4",
              attributes: { Name: "AI" },
            },
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "652",
              attributes: {
                url: "/partners/celuvplay.svg",
                width: 186,
                height: 37,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "7",
      attributes: {
        name: "DeGuard",
        description: "DePIN Web3 VPN service.",
        url: "https://deguard.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "8",
              attributes: { Name: "Auditors & Security" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "653",
              attributes: {
                url: "/partners/deguard.png",
                width: 4020,
                height: 960,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "23",
      attributes: {
        name: "Fandom",
        description:
          "Fandom Studio enhances the entertainment content industry, powering it with NFTs and other Web3 tools.",
        url: "https://fandom.co/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "10",
              attributes: { Name: "NFT" },
            },
            {
              id: "22",
              attributes: { Name: "Entertainment" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "670",
              attributes: {
                url: "/partners/fandom.png",
                width: 582,
                height: 140,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "25",
      attributes: {
        name: "NIRVANA Project",
        description:
          "An innovative platform that allows to connect points and digital assets from various platforms and games, providing incentives to developers and users. ",
        url: "https://nirvana-project.com/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "672",
              attributes: {
                url: "/partners/nirvana-project.png",
                width: 245,
                height: 80,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "32",
      attributes: {
        name: "Covenant Child",
        description:
          "Covenant Child brings a sustainable gaming experience, perfectly balancing rich gameplay, lore, and GameFi.",
        url: "https://covenantchild.game/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "720",
              attributes: {
                url: "/partners/covenant-child.png",
                width: 361,
                height: 200,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "17",
      attributes: {
        name: "TRALA",
        description:
          "TRALA is building a bridge between Web3 and Web2 gaming communities, creating a single GameFi environment that is accessible for players of all levels of crypto experience.",
        url: "https://trala.me/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
            {
              id: "13",
              attributes: { Name: "Infrastructure" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "664",
              attributes: {
                url: "/partners/trala.webp",
                width: 250,
                height: 250,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "18",
      attributes: {
        name: "TuringBitchain",
        description:
          "TBC enhances Bitcoin's scalability, aligning it with the network’s evolution and fostering a vibrant BVM ecosystem.",
        url: "https://turingbitchain.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "9",
              attributes: { Name: "BTCFI" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "665",
              attributes: {
                url: "/partners/turingbitchain.jpg",
                width: 400,
                height: 400,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "28",
      attributes: {
        name: " HypeBoy",
        description:
          "From NFT collections and a smart ticket system to global club partnerships and real-life events, HypeBoy is an all-in-one ecosystem for artistry.",
        url: "https://hypeboy.xyz/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
            {
              id: "22",
              attributes: { Name: "Entertainment" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "675",
              attributes: {
                url: "/partners/hypeboy.webp",
                width: 2048,
                height: 1128,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "10",
      attributes: {
        name: "LeisureMeta",
        description:
          "A cutting-edge Web3.0 protocol ushering in a transformative era for social, cultural, and economic interactions.",
        url: "https://leisuremeta.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
            {
              id: "6",
              attributes: { Name: "DAO" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "711",
              attributes: {
                url: "/partners/leisuremeta.png",
                width: 800,
                height: 111,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "15",
      attributes: {
        name: "Omniscia",
        description:
          "Omniscia is an industry expert in smart contract audit that has provided first-class security for over 500 projects.",
        url: "https://omniscia.io/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "8",
              attributes: { Name: "Auditors & Security" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "661",
              attributes: {
                url: "/partners/omniscia.png",
                width: 960,
                height: 720,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
    {
      id: "8",
      attributes: {
        name: "Pixer Eternity",
        description: " A global sports community united by Web3 spirit.",
        url: "https://pixer.club/",
        priority: 0,
        ecosystem_partner_categories: {
          data: [
            {
              id: "5",
              attributes: { Name: "GameFi" },
            },
            {
              id: "14",
              attributes: { Name: "SocialFi" },
            },
          ],
        },
        logo: {
          data: [
            {
              id: "654",
              attributes: {
                url: "/partners/pixer-eternity.png",
                width: 132,
                height: 92,
              },
            },
          ],
        },
        landing_logo: {
          data: [],
        },
      },
    },
  ] as const
).toSorted(
  (a, b) => (b.attributes.priority ?? 0) - (a.attributes.priority ?? 0)
);
